export enum RESPONSE_VALIDA {
    VALIDA = 1,
    REDIRECT = 2,
    SERVICE_ERROR_REDIRECT = 3,
    SUCCESS_AUTH_REDIRECT = 4,
}